import React, { useEffect } from 'react'
import { BASE_URL } from '../../config'
import aboutrightimg from '../../images/about-right-img.png'
import { Markup } from 'interweave';
import $ from 'jquery';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useHistory } from 'react-router-dom';

function AboutMe({data}) {
  let navigate = useHistory();
  useEffect(() => {

   
  }, [])
  
  return (
    <section className="abouthcontainer lazy" data-src={`${BASE_URL}/${data?.featured_image}`} style={{backgroundImage: `url(${aboutrightimg})`}}>
  <div className="container">
    <div className="row align-items-center">
      <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12 wow fadeInLeft">
        <div className="abouthimg">
          {/* <img className="" src={`${BASE_URL}/${data?.featured_image}`} width="526" height="393" alt=""/> */}
          <LazyLoadImage
          class="lazy"
      alt=""
      height={393}
      src={`${BASE_URL}/${data?.featured_image}`} // use normal <img> attributes as props
      width={526} />
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 wow fadeInRight">
        <div className="abouthcontent">
          <h2>About Me</h2>
          <Markup content={data?.page_content} />
          {/* <p>I have 28 years experience in CNC machine maintenance knowledge, at age of my 45 i got retired. Now my aim is sharing my knowledge to so many people who are interested to learn knowledge and earn money.</p>
          <p>I have experience of CNC machine maintenance since 1994 and worked with Fanuc, Siemens, Mitsubishi system having CNC machines also i have experience both electrical and mechanical maintenance.</p>
          <p>The training we are giving is very useful to learn industrial knowledge and also to earn money with your technical knowledge.</p>
          <p>You can start your own business and you can fulfill your and your family needs.</p> */}
          <a className="theme-btn" href="/about-me" onClick={(e)=>{e.preventDefault();navigate.push("/about-me")}}><span>Read More</span><i className="icon icon-long-arrow-right"></i></a>
        </div>
      </div>
    </div>
  </div>
</section>
  )
}

export default AboutMe